import type {Filter, FilterOperation, FilterType} from 'api/types';

export const getDefaultValue = (
  type: FilterType,
  operation: FilterOperation,
  oldValues?: Filter['values'],
): Array<string> => {
  switch (type) {
    case 'BOOLEAN':
      switch (operation) {
        case 'EQUAL':
          return ['true'];
        default:
          return [];
      }
    default:
      return oldValues || [];
  }
};
